import { LoginENTResponse } from '../../../../../types/api/endpoints/auth/login.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { LoginENTFormSchema } from './LoginENTForm.types';

const PREFIX = '[loginENTQuery]';

export const LOGIN_ENT_QUERY_KEY = 'LOGIN_ENT';

export const loginENTQuery = async ({ email, password }: LoginENTFormSchema) => {
  console.log(PREFIX, `Requesting ENT login...`);
  const response = await AUTH_ENDPOINTS.loginENT({ email, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received ENT login response.`);
  return json as LoginENTResponse;
};
